import { DiamondPackage } from "../_00Global/DiamondPackage";
import { GoldPackage } from "../_00Global/GoldPackage";
import { PlatinumPackage } from "../_00Global/PlatinumPackage";

export const _06BBody = (): JSX.Element => {
  return (
    <div className="flex w-full justify-center items-center py-[18px] mt-[15px] mb-[15px]">
      <div className="w-full max-w-[1440px] px-4">
        {/* Simple vertical stack on mobile, horizontal on desktop */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-[56px] lg:gap-[25px]">
          {/* Gold Package */}
          <div className="w-full flex justify-center lg:w-auto scale-[1.1] lg:scale-100 transform transition-all duration-300 lg:hover:scale-105 py-[80px]">
            <GoldPackage />
          </div>
          
          {/* Platinum Package */}
          <div className="w-full flex justify-center lg:w-auto scale-[1.1] lg:scale-100 transform transition-all duration-300 lg:hover:scale-105 py-[80px]">
            <PlatinumPackage />
          </div>
          
          {/* Diamond Package */}
          <div className="w-full flex justify-center lg:w-auto scale-[1.1] lg:scale-100 transform transition-all duration-300 lg:hover:scale-105 py-[80px]">
            <DiamondPackage />
          </div>
        </div>
      </div>
    </div>
  );
}; 